import React, { useMemo } from 'react';
import { useElementSize } from '@mantine/hooks';
import { Node } from 'reactflow';

import { GetFunctionResponse } from '@hud/portal-dtos/webapp-function.dto';

import { FlowChart } from '../../Charts/FlowChart/FlowChart';
import { NodeData } from '../../Charts/FlowChart/types';
import { generateNodesAndEdges, NodeGenerationOptions } from './utils';
import { NodeErrorConfig } from '@hud/portal-dtos/flow-chart.dtos';
import { EdgeInspector, NodeInspector } from './Inspector';

export const COMPACT_NODE_WIDTH = '30vw';

export interface FunctionFlowChartProps {
  height: number;
  width: number;
  functionData: GetFunctionResponse;
  useDynamicWidth?: boolean;
  onNodeClick?: (node: Node<NodeData>) => void;
  loading?: boolean;

  compact?: boolean;
  viewportNodeWidth?: boolean;
  showTinting?: NodeErrorConfig;

  options?: NodeGenerationOptions;
}

export function FunctionFlowChart({
  height,
  width,
  functionData,
  loading,
  useDynamicWidth = false,
  onNodeClick = () => ({}),
  compact = false,
  showTinting,
  options,
}: FunctionFlowChartProps) {
  const { ref, width: dynamicWidth } = useElementSize();
  const [capCallers, setCapCallers] = React.useState(true);
  const [capCallees, setCapCallees] = React.useState(true);

  const [nodes, edges] = useMemo(() => {
    const nodes = generateNodesAndEdges(
      functionData,
      capCallers,
      capCallees,
      compact,
      loading,
      showTinting,
      options
    );
    return nodes;
  }, [functionData, capCallers, capCallees, loading]);

  const effectiveWidth = useDynamicWidth ? dynamicWidth : width;
  return (
    <div ref={ref}>
      {  effectiveWidth > 0 &&
        <FlowChart
          initialNodes={nodes}
          initialEdges={edges}
          height={height}
          width={effectiveWidth}
          loading={loading}
          onNodeClick={onNodeClick}
          onCTANodeClick={(node) => {
            if (node.data.cta === 'toggle-callers') {
              setCapCallers(!capCallers);
            } else if (node.data.cta === 'toggle-callees') {
              setCapCallees(!capCallees);
            }
          }}
          EdgeInspectorComponent={EdgeInspector}
          NodeInspectorComponent={NodeInspector}
        />
      }
    </div>
  );
}
